const countyConfigCommonReducer = (state = [], action) => {
  switch (action.type) {
    case 'LANDNOTIFICATION_COUNTY_CONFIG_COMMON':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigCommonReducer;